import React from 'react';
import { Link } from 'react-router-dom';
import { animateScroll as scroll, scroller} from 'react-scroll';
/* eslint-disable */

export default function PageNavigation() {
  const scrollFunc=(e)=>{
    if(e==='home'){
      scroll.scrollToTop()
    }
    else {
      scroller.scrollTo(e, {
        duration: 1400,
        delay: 0,
        offset: 25,
        smooth: 'easeInOutQuart'
      })
    }

  }

  const navStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    boxShadow: "0 2px 20px rgba(23, 57, 98, 0.08)",
    padding: "8px 0",
    borderBottom: "1px solid rgba(23, 57, 98, 0.05)"
  };

  const logoContainerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "4px 16px",
    cursor: "pointer",
    transition: "transform 0.2s ease"
  };

  const buttonContainerStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "8px 16px"
  };

  const togglerStyle = {
    border: "2px solid #173962",
    padding: "6px 10px",
    borderRadius: "8px",
    backgroundColor: "transparent"
  };

  return (
    <div>
      <nav className="navbar fixed-top navbar-expand-lg" style={navStyle} id="mainNavbar">

        <div className="navbar-brand" id="navMain-1" style={logoContainerStyle} data-toggle="collapse" data-target=".navbar-collapse.show" >
          <Link role="button" to="/" style={{display: "flex", alignItems: "center", gap: "10px"}}>
            <img
              src={require('../../Assets/img/Navigation/nav_icon.png')}
              width="45"
              height="36"
              className="d-inline-block align-top"
              alt="NeedForGeeks Logo"
              style={{
                filter: "drop-shadow(0 2px 4px rgba(23, 57, 98, 0.1))",
                transition: "transform 0.2s ease"
              }}
            />
            <img
              src={require('../../Assets/img/Navigation/Logo_text.png')}
              className="d-inline-block align-top"
              alt="NeedForGeeks"
              style={{
                height: "28px",
                width: "auto"
              }}
            />
          </Link>
        </div>

        <button
          style={togglerStyle}
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#main-navbar"
          aria-controls="main-navbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" style={{
            backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%23173962' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")`
          }}></span>
        </button>

        <div className="collapse navbar-collapse" id="main-navbar">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item" id="navMain-2"></li>
            <li className="nav-item" id="navMain-4"></li>
          </ul>
          <div style={buttonContainerStyle} data-toggle="collapse" data-target=".navbar-collapse.show">
            <Link className="btn btn-outline-navi" role="button" to="/it">
              Information Technology
            </Link>
            <Link className="btn btn-outline-navi" role="button" to="/web-app">
              Websites & Apps
            </Link>
            <Link className="btn btn-outline-navi" role="button" to="/automation">
              Automation
            </Link>
          </div>
        </div>

      </nav>
    </div>
  );

}